<div id="burger-menu">
    <span
        class="d-inline-flex align-items-end"
        [ngClass]="{ 'ms-3': isMenuExpanded, 'ms-4': !isMenuExpanded }"
    >
        <input
            type="checkbox"
            id="checkbox"
            class="checkbox visuallyHidden"
            [checked]="checkedState"
            (click)="toggleCollapse()"
        />
        <label for="checkbox" class="mb-0">
            <div class="hamburger" [ngClass]="{ 'me-1': isMenuExpanded }">
                <span class="bar bar-1"></span>
                <span class="bar bar-2"></span>
                <span class="bar bar-3"></span>
                <span class="bar bar-4"></span>
            </div>
        </label>
        <h4 class="ms-2" *ngIf="menuTitle" (click)="toggleCollapse()">{{ menuTitle }}</h4>
    </span>
    <ng-content> </ng-content>
</div>
